<div #inventoryRoot class="inventory-root">
<div #pinnedControls class="inventory-pinned-controls">
<div class="inventory-toolbar">
  <label class="select-references"><input type="checkbox" [checked]="allSelected" [indeterminate]="someSelected" (change)="selectAll($any($event.target).checked)"> Select all references</label>
  <rms-checkbox label="Group by futures month" [(ngModel)]="groupByMonth" (ngModelChange)="rebuild()"></rms-checkbox>
  <rms-select label="Sort references by" [options]="sortOptions" labelKey="label" valueKey="value" [(ngModel)]="sortBy" (ngModelChange)="rebuild()"></rms-select>
  <button mat-button class="btn-bg-blue" [disabled]="!selectedRows.length || editorSKUs.length>0" (click)="openPricing()">Open price update ({{selectedRows.length}} refs)</button>
@if(excluded.length) { <button type="button" mat-button class="btn-bg-blue restore-top" (click)="restoreAll()">Restore all ({{excluded.length}} excluded)</button> }
</div>
@if(editorSKUs.length){
  <section class="embedded-pricing" aria-label="Price update">
    <app-sku-price-update [embedded]="true" [skus]="editorSKUs" (dismissed)="closePricing()" (removed)="removeSKUs($event)" (saved)="pricingSaved($event)"></app-sku-price-update>
  </section>
}
</div>
<p class="summary-help">All selected SKUs are combined below. Averages use included references; excluding a reference changes this pricing view only.</p>
@for(section of sections; track section.title) {
  <section class="inventory-section">
    <h3>{{section.title}}</h3>
    <div class="inventory-table"><rms-table [data]="section.rows" [footerRows]="summaryRows(section)" [columns]="inventoryColumns" [icons]="icons" [IncludePaginator]="false" [IncludeSearch]="false"></rms-table></div>
  </section>
}
@if(!sections.length) { <p role="status">No included references for this view.</p> }
@if(excluded.length) {
  <section class="inventory-section excluded-references"><h3>Excluded references ({{excluded.length}}) <button mat-button class="btn-bg-blue" (click)="restoreAll()">Restore all</button></h3>
    <div class="inventory-table"><rms-table [data]="excluded" [columns]="inventoryColumns" [icons]="restoreIcons" [IncludePaginator]="false" [IncludeSearch]="false"></rms-table></div>
  </section>
}

</div>
